// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"817":"6ee5065b","982":"48564a40"}[chunkId] + ".css";
};